// src/pages/admin/tabs/districts/DistrictsListPage.jsx
import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { AdminAPI } from '../../../../api/admin';
import { Card, Row2, Field, Actions, Btn, Badge, TableWrap, Table, Paginator, PageBtn } from '../../ui';

const Wrap = styled.div`display:grid; gap:20px;`;

export default function DistrictsListPage(){
  const [regions, setRegions] = React.useState([]);
  const [query, setQuery] = React.useState({ page:1, page_size:50, region_id:'', is_active:'', q:'' });
  const [items, setItems] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState('');
  const nav = useNavigate();

  const totalPages = Math.max(1, Math.ceil((total || items.length) / (query.page_size || 50)));

  const loadRegions = React.useCallback(async ()=>{
    try{ const r = await AdminAPI.listRegions({ page_size: 1000 }); setRegions(r.regions || []); }catch(e){ console.error(e); }
  },[]);

  const load = React.useCallback(async ()=>{
    setLoading(true); setErr('');
    try{
      const d = await AdminAPI.listDistricts({
        page: query.page,
        page_size: query.page_size,
        region_id: query.region_id || undefined,
      });
      const list = d?.districts || d?.items || [];
      const tot  = d?.pagination?.total ?? list.length;
      setItems(list); setTotal(tot);
    }catch(e){
      console.error(e);
      setErr(e?.payload?.details || e?.message || 'Не удалось загрузить районы');
      setItems([]); setTotal(0);
    }finally{ setLoading(false); }
  }, [query]);

  React.useEffect(()=>{ loadRegions(); }, [loadRegions]);
  React.useEffect(()=>{ load(); }, [load]);

  const goPage = (n) => setQuery(q => ({ ...q, page: Math.max(1, Math.min(n, totalPages)) }));

  const del = async (id)=>{
    if(!window.confirm('Удалить район? Если есть объекты — удаление будет отклонено.')) return;
    try{ await AdminAPI.deleteDistrict(id); await load(); }
    catch(err){ alert(err?.payload?.details || err?.message || 'Ошибка удаления'); }
  };

  return (
    <Wrap>
      <Card>
        <h3>Районы</h3>
        <Actions style={{marginTop:8, gap:10, flexWrap:'wrap', alignItems:'end'}}>
          <Field>Регион
            <select value={query.region_id} onChange={e=>setQuery(q=>({...q, region_id:e.target.value, page:1}))}>
              <option value="">все</option>
              {regions.map(r=> <option key={r.id} value={r.id}>{r.name_ru || r.name_en} ({r.code})</option>)}
            </select>
          </Field>
          <Field>На странице
            <select value={query.page_size} onChange={e=>setQuery(q=>({...q, page_size:Number(e.target.value), page:1}))}>
              <option value={20}>20</option><option value={50}>50</option><option value={100}>100</option><option value={200}>200</option>
            </select>
          </Field>
          <Btn onClick={()=>setQuery({ page:1, page_size:50, region_id:'', is_active:'', q:'' })}>Сброс</Btn>
          <Btn onClick={load}>Обновить</Btn>
          <Badge>Найдено: <b>{total || items.length}</b></Badge>
          <div style={{flex:1}} />
          <Btn $kind="primary" onClick={()=>nav('/admin/districts/new')}>+ Создать район</Btn>
        </Actions>
      </Card>

      <Card>
        <h3>Список {loading ? '(загрузка...)' : ''}</h3>
        {err && <div style={{color:'#e66', marginBottom:8}}>{String(err)}</div>}
        <TableWrap>
          <Table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Название</th>
                <th>Регион</th>
                <th>Slug</th>
                <th>Активен</th>
                <th>Сортировка</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map(d=>{
                const region = regions.find(r=>r.id === d.region_id);
                return (
                  <tr key={d.id}>
                    <td>{d.id}</td>
                    <td style={{maxWidth:320}}>
                      <div style={{fontWeight:700}}>{d.name_ru || d.name_en}</div>
                      <div style={{opacity:.7, fontSize:13}}>{d.name_en}</div>
                    </td>
                    <td>{region ? (region.name_ru || region.name_en) : d.region_id}</td>
                    <td>{d.slug}</td>
                    <td>{d.is_active ? 'Да' : 'Нет'}</td>
                    <td>{d.sort_order ?? 0}</td>
                    <td style={{display:'flex', gap:8}}>
                      <Link className="btn" to={`/admin/districts/${d.id}`} state={{ district: d }}>Редактировать</Link>
                      <Btn onClick={()=>del(d.id)}>Удалить</Btn>
                    </td>
                  </tr>
                );
              })}
              {!items.length && !loading && (
                <tr><td colSpan={7} style={{opacity:.7}}>Нет данных</td></tr>
              )}
            </tbody>
          </Table>
        </TableWrap>

        <Paginator>
          <PageBtn onClick={()=>goPage(1)} disabled={query.page<=1}>« Первая</PageBtn>
          <PageBtn onClick={()=>goPage(query.page-1)} disabled={query.page<=1}>‹ Назад</PageBtn>
          <PageBtn data-active="true">{query.page} / {totalPages}</PageBtn>
          <PageBtn onClick={()=>goPage(query.page+1)} disabled={query.page>=totalPages}>Вперёд ›</PageBtn>
          <PageBtn onClick={()=>goPage(totalPages)} disabled={query.page>=totalPages}>Последняя »</PageBtn>
        </Paginator>
      </Card>
    </Wrap>
  );
}


